import React from "react";
import './RegisterDoktorRightSideSecond.css';
import LogoRegister from "../../../assets/images/logo-buyuk.png";

const RegisterDoktorRightSideSecond = () => {

    return (
        <div className="success-container">
            <img src={LogoRegister} alt="Logo" />
            {/* Yuvarlak ikon */}
            <div className="icon-circle">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="icon-check"
                    fill="none"
                >
                    <path
                        d="M4.5 12.75l6 6 9-13.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        stroke="white"
                        strokeWidth="2"
                    />
                </svg>
            </div>

            {/* Mesajlar */}
            <p className="message">
                Terapist/Doktor kaydınız alınmıştır; <br />
                size en yakın zamanda dönüş yapılacaktır.
            </p>
            <p className="mail-message">Mail Adresinizi Kontrol Etmeyi Unutmayın!</p>
        </div>
    );
};


export default RegisterDoktorRightSideSecond;
